/**
 * Mengkonversi tanggal string format "DD Bulan YYYY" menjadi nama hari
 * @param tanggal - String tanggal dalam format "DD Bulan YYYY" (contoh: "15 Januari 2024")
 * @returns Nama hari dalam bahasa Indonesia atau string kosong jika gagal
 */
export function getHariFromTanggal(tanggal: string): string {
    if (!tanggal) return '';
    const [tgl, bulan, tahun] = tanggal.split(' ');
    const bulanMap: { [key: string]: number } = {
        'Januari': 0, 'Februari': 1, 'Maret': 2, 'April': 3, 'Mei': 4, 'Juni': 5,
        'Juli': 6, 'Agustus': 7, 'September': 8, 'Oktober': 9, 'November': 10, 'Desember': 11
    };
    try {
        const bulanIdx = bulanMap[bulan as keyof typeof bulanMap] ?? -1;
        if (bulanIdx === -1) return '';
        const date = new Date(parseInt(tahun), bulanIdx, parseInt(tgl));
        return date.toLocaleDateString('id-ID', { weekday: 'long' });
    } catch {
        return '';
    }
}

/**
 * Ekstrak jam mulai dari string jam Superadmin, contoh input:
 * - "19.00 - 22.00" => "19.00"
 * - "19.00 - Selesai" => "19.00"
 * - "19:00 - 22:00" => "19:00"
 * - "19.00" => "19.00"
 */
export function parseJamMulai(jamRaw?: string | null): string | null {
    if (!jamRaw) return null;
    const s = jamRaw.toString().trim();
    if (!s) return null;
    // Ambil token pertama sebelum pemisah "-"
    const firstPart = s.split('-')[0].trim();
    // Validasi pola HH.mm atau HH:mm atau H.mm/H:mm
    const match = firstPart.match(/^(\d{1,2}([.:]\d{2})?)$/);
    if (match) return match[1];
    // Coba cari jam di awal string
    const anyMatch = s.match(/(\d{1,2}[.:]\d{2})/);
    return anyMatch ? anyMatch[1] : null;
}